import { NavigationStatusCardVariantType, TagVariantType } from '../../variants';
import { commonStyles } from '../commonStyles';
export const getOnlineStyles = (FOUNDATIONS, FONT) => {
    return {
        [NavigationStatusCardVariantType.ONLINE]: {
            ...commonStyles(FOUNDATIONS),
            tag: {
                ...commonStyles(FOUNDATIONS).tag,
                variant: TagVariantType.SUCCESS,
            },
            mainWrapperWhenExtraAction: {
                ...commonStyles(FOUNDATIONS).mainWrapperWhenExtraAction,
                background_color: FOUNDATIONS.color_comp_navigation_navigationstatuscard_success_bg,
            },
            infoContainer: {
                ...commonStyles(FOUNDATIONS).infoContainer,
                background_color: FOUNDATIONS.color_comp_navigation_navigationstatuscard_success_bg,
            },
            extraInfoContainer: {
                ...commonStyles(FOUNDATIONS).extraInfoContainer,
                background_color: FOUNDATIONS.color_comp_navigation_navigationstatuscard_success_bg,
            },
            actionLinkContainer: {
                ...commonStyles(FOUNDATIONS).actionLinkContainer,
                background_color: FOUNDATIONS.color_comp_navigation_navigationstatuscard_success_bg,
            },
            iconHighlighted: {
                ...commonStyles(FOUNDATIONS).iconHighlighted,
                backgroundColor: FOUNDATIONS.color_exception_feedback_success_bg_250,
                color: FOUNDATIONS.color_feedback_success_icon_50,
            },
        },
    };
};
//# sourceMappingURL=online.js.map